<template>
  <div>
    <div class="pay-total">
      <div class="price">
        <div style="font-size: 0.25rem; color: #000;">订单金额</div>
        <div>¥{{ orderInfo.amount }}</div>
      </div>
      <!-- <price-convert class="price" :price="orderInfo.amount"></price-convert> -->
    </div>
    <Coupon :info="orderInfo.card" v-model="couponId" v-if="isSubmitOrder"></Coupon>
    <div class="residual-price">剩余还需支付：<span>¥{{ residualPrice }}</span></div>
    <PayOptions v-model="payType" :payInfo="orderInfo">
    </PayOptions>
    <div class="pay-action">
      <van-button
      round
      block
      @click="submitOrder"
      color="#5a9dff"
      :loading="loading"
      loading-text="支付中..."
      :disabled="loading">确认支付</van-button>
    </div>
  </div>
</template>
<script>
import { getMoviePayInfoApi } from '@/api/pay'
import { PayOptions, Coupon } from './components'
import { Button } from 'vant'
import { payOrderHandle } from '@/utils/payment'
import { getOrderDetail } from '@/api/user'

export default {
  components: {
    PayOptions,
    Coupon,
    [Button.name]: Button
  },
  data () {
    return {
      orderInfo: {},
      payType: 3,
      loading: false,
      couponId: '',
      isSubmitOrder: false // 是否已经提交订单

    }
  },
  computed: {
    residualPrice () {
      if (this.couponId) {
        const couponPrice = this.orderInfo.card.find(item => item.id === this.couponId).d_surplus
        // 精准计算 到两位小数点
        const num = Number(this.orderInfo.amount) - Number(couponPrice)
        return num < 0 ? 0 : num.toFixed(2)
      }
      return this.orderInfo.amount
    }
  },
  methods: {
     async getMovieOrderInfo () {
      this.loading = true;
     const result = await getOrderDetail({
        order_sn: this.orderInfo.order_sn
     }).catch(() => {
      this.loading = false;
     })
      this.loading = false;
      console.log(result);
       const routeUrl = result.data.data.extra.order_detail
        window.location.href = routeUrl
      // if (result.data.data.status) {
      //   const routeUrl = result.data.data.data.extra.order_detail
      //   window.location.href = routeUrl
      // }
    },
    async submitOrder () {
      this.loading = true
      const result = await payOrderHandle({
        orderId: this.$route.query.order_id,
        payType: this.payType,
        payId: this.orderInfo.pay_id,
        couponId: this.couponId
      }).catch(() => {
        this.loading = false
      })
      this.loading = false
      this.$toast(result.message)
      // console.log(result, 666666);
      if (result.status) {
        this.getMovieOrderInfo()
      } else {
        if (result.message.indexOf('本支付单已经付款成功') > -1) {
          this.getMovieOrderInfo()
        }
      }
    },
    // async submitOrder () {
    //   this.loading = true;
    //   const result = await this.movieOrderPay({
    //     orderId: this.$route.query.order_id,
    //     paymentType: this.payType,
    //     pay_id: this.orderInfo.pay_id
    //   }).catch(() => {
    //     this.loading = false;
    //   })
    //   this.loading = false;
    //   if (result.data.data.status) {
    //     window.location.href = result.data.data.data.url
    //   }
    // },
    async getMovieGoods() {
      const { order_id } = this.$route.query;
      const result = await getMoviePayInfoApi({
        order_id: order_id
      })
      if (result.data.data.status) {
        this.orderInfo = result.data.data.payInfo
        console.log(this.orderInfo.is_change_pay);
        
        this.isSubmitOrder = this.orderInfo.is_change_pay
      }
    },
    getPayInfoHandle () {
      const { payType } = this.$route.query;
       if (payType && payType === 'movie') {
          this.getMovieGoods()
        } else {
          this.$toast('订单类型错误')
      }
    },
    async onSubmit () {

    }
  },
  created () {
    if (window.location.href.indexOf("?#") < 0) {
      window.location.href = window.location.href.replace("#", "?#");
    }
    
    this.getPayInfoHandle()
  }
}
</script>
<style lang="scss" scoped>
  .pay-total{
    color: #DE1C24;
    padding: 1rem;
    text-align: center;
    font-size: 0.5rem;
    .price {
      margin: auto;
    }
  }
  .pay-action{
    margin: 0 auto;
    margin-top: 8rem;
    text-align: center;
    width: 90%;
  }
  .residual-price{
     width: 90%;
     margin: 0 auto;
    font-size: 0.28rem;
    color: #666666;
    span {
      color: #DE1C24;
    }
  }
</style>